export default __webpack_public_path__ + "assets/webgl/scene-4.d98baae6.glb";